import { Check } from 'lucide-react';
import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

export const ModalContainer = styled.div`
  background: white;
  border-radius: 4px;
  width: 95%;
  max-width: 1400px;
  height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;
  color: red;

  &:hover {
    background-color: #e0e0e0;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ModalBody = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

export const MapContainer = styled.div`
  flex: 1;
  position: relative;
  background: #f5f5f5;
`;

export const Sidebar = styled.div`
  width: 320px;
  background: white;
  border-left: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ProgressSection = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #4caf50, #45a049);
  transition: width 0.3s ease;
  width: ${(props) => props.progress}%;
`;

export const ProgressText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #666;
  text-align: center;
`;

export const CurrentOverlaySection = styled.div`
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
`;

export const OverlayLabel = styled.p`
  margin: 0 0 8px 0;
  font-size: 12px;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
`;

export const OverlayName = styled.h3`
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 600;
`;

export const CompletedList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
`;

export const CompletedItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  background: #f0f9ff;
  border-radius: 6px;
  margin-bottom: 8px;
  border: 1px solid #bae6fd;
`;

export const CheckIcon = styled(Check)`
  color: #0ea5e9;
  margin-right: 12px;
  flex-shrink: 0;
`;

export const CompletedItemText = styled.span`
  font-size: 14px;
  color: #333;
  flex: 1;
`;

export const ButtonContainer = styled.div`
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  display: flex;
  gap: 12px;
`;

export const Button = styled.button`
  flex: 1;
  padding: 12px 24px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.2s;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const CaptureButton = styled(Button)`
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  font-family: 'JetBrains Mono Regular';

  &:hover:not(:disabled) {
    background: linear-gradient(90deg, #7b5cff, #60a5fa);
    transform: translateY(-1px);
  }
`;

export const CompleteButton = styled(Button)`
  background: #4caf50;
  color: white;
  font-family: 'JetBrains Mono Regular';

  &:hover:not(:disabled) {
    background: #45a049;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
  }
`;

export const ErrorMessage = styled.div`
  margin: 16px 20px;
  padding: 12px;
  background: #ffebee;
  border: 1px solid #ef5350;
  border-radius: 6px;
  color: #c62828;
  font-size: 14px;
`;
export const SuccessMessage = styled.div`
  margin: 16px 20px;
  padding: 12px;
  background: #e8f5e9;
  border: 1px solid #4caf50;
  border-radius: 6px;
  color: #2e7d32;
  font-size: 14px;
`;
export const SummarySection = styled.div`
  padding: 12px;
  background-color: #e3f2fd;
  border-left: 4px solid #2196f3;
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const SummaryText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #1565c0;
  font-weight: 500;
`;
